export default __webpack_public_path__ + "static/media/carousel4.a3f42c51.jpg";